<template>
  <v-container grid-list-xs class="pa-0">
    <v-layout row wrap>
      <v-flex
        xs12
        md6
        class="elevation-6 border-right text-xs-center offset-md3"
      >
        <v-card class="elevation-4">
          <v-card-title class="info white--text">
            <h2 class="headline">Register for Free</h2>
          </v-card-title>
          <p>
            Save your pool and spa volume and surface settings. You can also
            start a premium trial to enjoy an ad-free experience, record your
            test history, and log your chemical history for up to 5 pools
          </p>
          <PCForm :fields="fields" class="pa-3" @save="submit">
            <template v-slot:submit>
              <p class="text-xs-center">
                Already have an account?
                <a @click="$router.push('login')">Log In</a>
              </p>
              <v-btn block round color="info" class="mt-3" type="submit">
                <div class="loader" v-if="loading"></div>
                <span v-else>Register</span>
              </v-btn>
            </template>
          </PCForm>
        </v-card>
        <v-snackbar v-model="snackbar.show" :bottom="true" :right="true">
          {{ snackbar.message }}
          <v-btn color="red" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import PCForm from "@/components/PCForm";
import { countries, countryNames, getCountryName } from "@/countries";

export default {
  components: { PCForm },
  data() {
    return {
      fields: [
        {
          name: "First Name",
          type: "text",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          name: "Last Name",
          type: "text",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          name: "Email",
          type: "email",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          name: "Country",
          type: "select",
          value: "",
          items: countryNames,
          classes: ["pl1", "xs12"],
        },
        {
          name: "Postal Code",
          type: "text",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          type: "radio",
          value: "Pool Owner",
          items: ["Pool Owner", "Pool Professional"],
          classes: ["pl1", "xs12"],
        },
        {
          name: "Password",
          type: "password",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          name: "Sign up for our Newsletter",
          type: "checkbox",
          value: false,
          classes: ["pl1", "xs12"],
        },
      ],
      loading: false,
      snackbar: {
        show: false,
        message: "",
      },
    };
  },
  methods: {
    ...mapActions({
      register: "user/register",
    }),
    async submit() {
      this.loading = true;
      try {
        console.log(this.fields);
        await this.register({
          firstName: this.fields[0].value,
          lastName: this.fields[1].value,
          email: this.fields[2].value,
          country: this.fields[3].value,
          postalCode: this.fields[4].value,
          type: this.fields[5].value,
          password: this.fields[6].value,
          newsletterSubscribed: this.fields[7].value,
        });
        this.$router.push({
          name: "account.billing",
          query: { fromRegistration: true },
        });
      } catch (err) {
        this.snackbar = { show: true, message: err.message };
        this.loading = false;
      }
    },
    getLastRoute() {
      var lastRoute = localStorage.getItem("LS_ROUTE_KEY");
      return lastRoute;
    },
  },
  mounted() {
    fetch(process.env.VUE_APP_IP_INFO_URL)
      .then((res) => {
        if (res.status < 200 || res.status >= 300) {
          return res.text().then(Promise.reject.bind(Promise));
        }

        return res.json();
      })
      .catch((err) => {
        console.error("Failed to check country:", err);
        return { country: "US" };
      })
      .then(({ country }) => {
        const result = countries.find((x) => x.codes.alpha2 === country);
        return getCountryName(result);
      })
      .then((name) => {
        console.log("got", name, this.fields[3].value);
        if (this.fields[3].value === "") {
          this.fields[3].value = name;
        }
      });
  },
};
</script>
